{
  "title": "Debtors",
  "addDebtor": "Add debtor",
  "editDebtor": "Edit debtor",
  "vehiclesPage": "Vehicles",
  "addVehicle": "Add vehicle",
  "adjustBalance": "Adjust total debt",
  "searchLabel": "Search by name or phone",
  "searchPlaceholder": "Search by name or phone...",
  "fields": {
    "name": "Debtor name",
    "phone": "Phone number",
    "debtLimit": "Debt limit",
    "branch": "Branch",
    "notes": "Notes",
    "vehiclePlate": "Vehicle number",
    "amount": "Amount",
    "phoneInvalid": "Invalid phone number"
  },
  "columns": {
    "number": "Number",
    "name": "Debtor name",
    "phone": "Phone number",
    "branch": "Branch",
    "totalDebt": "Total debt",
    "debtLimit": "Debt limit",
    "linkStatus": "Customers link",
    "createdBy": "Created by",
    "createdAt": "Created at",
    "notes": "Notes",
    "addedAt": "Added at",
    "vehiclePlate": "Vehicle number",
    "actions": "Actions"
  },
  "shared": "Shared",
  "linkStatus": {
    "LINKED": "Linked",
    "PENDING": "Awaiting link",
    "INVALID_PHONE": "Invalid number"
  },
  "linkStatusFilterLabel": "Customers link",
  "linkStatusFilterAll": "All link statuses",
  "branchFilterShared": "Shared",
  "invalidPhoneFlag": "Invalid number",
  "totals": {
    "totalDebts": "Total debts"
  },
  "drawer": {
    "createDescription": "Enter the new debtor's details. Required fields are marked with an asterisk.",
    "editDescription": "Edit the debtor's details. The total debt cannot be edited here.",
    "requiredFieldsNote": "Required fields are marked with an asterisk",
    "saving": "Saving...",
    "branchPlaceholder": "Shared (no branch)",
    "discardTitle": "Discard changes?",
    "discardDescription": "The changes you made will not be saved.",
    "discardConfirm": "Discard",
    "discardCancel": "Keep editing"
  },
  "vehicleDrawer": {
    "title": "Add vehicle",
    "description": "Enter the vehicle number. Required fields are marked with an asterisk."
  },
  "adjustDialog": {
    "title": "Adjust total debt",
    "description": "Enter a positive amount to increase the debt or a negative one to decrease it for {{name}}.",
    "currentBalance": "Current balance",
    "resultingBalance": "Resulting balance",
    "confirm": "Confirm",
    "amountRequired": "Enter a non-zero amount"
  },
  "confirmDelete": {
    "title": "Delete debtor?",
    "description": "The debtor \"{{name}}\" (current balance {{balance}}) will be deleted. It can be restored later from the trash."
  },
  "confirmDeleteVehicle": {
    "title": "Delete vehicle?",
    "description": "The vehicle \"{{plate}}\" will be deleted. It can be restored later from the trash."
  },
  "toasts": {
    "created": "Debtor created successfully",
    "updated": "Debtor updated successfully",
    "deleted": "Debtor deleted successfully",
    "balanceAdjusted": "Total debt adjusted successfully",
    "vehicleCreated": "Vehicle added successfully",
    "vehicleDeleted": "Vehicle deleted successfully"
  },
  "rowActions": {
    "vehicles": "Vehicles",
    "trigger": "Actions for {{name}}"
  },
  "vehiclesHeader": {
    "balance": "Current balance",
    "debtLimit": "Debt limit",
    "back": "Back to debtors"
  },
  "empty": {
    "noResults": "No results",
    "noData": "No data available",
    "noVehicles": "This debtor has no vehicles"
  }
}
